import {AfterContentInit, Component, Inject, Input, PLATFORM_ID, ViewChild} from '@angular/core';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {isPlatformBrowser} from '@angular/common';
import {MessageComponent} from 'ng-design-system';
import {DcpProductUtilitiesService} from '@app/product/services/dcp-product-utilities.service';

@Component({
  selector: 'dcp-remove-product-success-message',
  templateUrl: './remove-product-success-message.component.html',
})
export class RemoveProductSuccessMessageComponent implements AfterContentInit {

  @Input() orderEntry: OrderEntry;
  @ViewChild(MessageComponent, {static: true}) messageComponent: MessageComponent;

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    public productUtils: DcpProductUtilitiesService,
  ) {
  }

  ngAfterContentInit() {
    this.focusCloseBtn();
  }

  focusCloseBtn() {
    if (isPlatformBrowser(this.platformId)) {
      this.messageComponent.focusCloseButton();
    }
  }
}
